import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useToken } from '@chakra-ui/react';
import { chakraComponents, CreatableSelect as ReactSelect } from 'chakra-react-select';
import { useTranslation } from 'react-i18next';
import { chakraReactSelectStyles, TooltipSelectOption } from './Select';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreatableSelect(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useToken = useToken('zIndices', ['modal']),
      _useToken2 = _slicedToArray(_useToken, 1),
      zIndexDropdown = _useToken2[0];

  return /*#__PURE__*/_jsx(ReactSelect, _objectSpread(_objectSpread({
    useBasicStyles: true,
    chakraStyles: chakraReactSelectStyles,
    formatCreateLabel: function formatCreateLabel(key) {
      return t('common:normal.resultIncludeSomething', "\u5305\u542B\u300E".concat(key, "\u300F\u7684\u7D50\u679C"), {
        key: key
      });
    },
    createOptionPosition: "first",
    menuPortalTarget: document.body,
    menuPosition: "fixed",
    placeholder: props.placeholder || t('common:normal.all', '全部'),
    styles: {
      menuPortal: function menuPortal(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          zIndex: zIndexDropdown
        });
      }
    },
    components: {
      Option: props.optionWithTooltip ? TooltipSelectOption : chakraComponents.Option
    }
  }, props), {}, {
    e2eid: "Form_CreatableSelect_ReactSelect"
  }));
}